// Custom-action names for the contract flow, sent to both Datadog RUM and Adobe via trackAction
// (@consumer-frontend/shared). Centralized so the names Datadog dashboards and monitors, and Adobe
// Launch rules, key on live in one place and can't drift or collide across the call sites that emit them.
export const CONTRACT_RUM_ACTIONS = {
  ALL_AUTH_AGREEMENT_REVIEWED: 'contractAllAuthAgreementReviewed',
  MODAL_AGREED: 'contractModalAgreed',
  MODAL_OPENED: 'contractModalOpened',
  MODAL_SCROLLED_TO_END: 'contractModalScrolledToEnd',
  NAVIGATION_BACK: 'contractNavigationBack',
  NAVIGATION_NEXT: 'contractNavigationNext',
  SIGNED: 'contractSigned',
  SIGNING_DURATION: 'contractSigningDuration',
  STEP_INVALID: 'contractStepInvalid',
} as const;
